import React from "react";

function Footer() {
  return (
    <div>
      <footer className="bg-body-tertiary text-center">
        {/* Grid container */}
        <div className="container p-4 pb-0">
          {/* Section: Social media */}
          <section className="mb-4"></section>
          {/* Facebook */}
          <a
            data-mdb-ripple-init=""
            className="btn text-white btn-floating m-1"
            style={{ backgroundColor: "#3b5998" }}
            href="#!"
            role="button"
          >
            <i className="fab fa-facebook-f" />
          </a>
          {/* Instagram */}
          <a
            data-mdb-ripple-init=""
            className="btn text-white btn-floating m-1"
            style={{ backgroundColor: "#ac2bac" }}
            href="#!"
            role="button"
          >
            <i className="fab fa-instagram" />
          </a>
          {/* whatsapp */}
          <a
            data-mdb-ripple-init=""
            className="btn text-white btn-floating m-1"
            style={{ backgroundColor: "#25d366" }}
            href="https://wa.me/201001193110"
            role="button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp" />
          </a>
          {/* Section: Social media */}
        </div>
        {/* Grid container */}
        {/* Copyright */}
        <div
          className="text-center p-3 copyright"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          © 2026 Copyright Design By:
          <b>
            <a className="text-body" href="https://protfoilo7.netlify.app/">
              Hamdy Reda
            </a>
          </b>
        </div>
        {/* Copyright */}
      </footer>
    </div>
  );
}

export default Footer;
